import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";


export default function SliderHomeGallery() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@0.75': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@1.00': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@1.50': {
                        slidesPerView: 4,
                        spaceBetween: 20,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper"
            >

                <SwiperSlide>
                    <div className="container">
                        <img className="" src="assets/solar/c3.webp" alt />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="container">
                        <img className="" src="assets/solar/c4.webp" alt />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="container">
                        <img className="" src="assets/solar/c5.webp" alt />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="container">
                        <img className="" src="assets/solar/c6.webp" alt />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="container">
                        <img className="" src="assets/solar/c1.webp" alt />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="container">
                        <img className="" src="assets/solar/c2.webp" alt />
                    </div>
                </SwiperSlide>
            </Swiper>
        </>
    );
}
